import { ConfigQrCode } from '@codecorp/advanced-configuration'
import { Button, QrCodeProps, useModal } from '@codecorp/components'
import { Cross1Icon } from '@radix-ui/react-icons'

export interface ShowBarcodeProps extends Omit<QrCodeProps, 'data'> {
    readonly barcode: string
    readonly label: string
    showPrintDownloadButtons?: boolean
}

export const ShowBarcode = ({
    barcode,
    label,
    showPrintDownloadButtons,
    ...qrCodeProps
}: ShowBarcodeProps) => {
    const { close } = useModal()

    return (
        <div>
            {!label.includes('Combiner Code') && !label.includes('Segment') && (
                <div>
                    <Button
                        onPress={close}
                        className="absolute top-5 right-6 z-20 flex h-8 w-8 items-center justify-center"
                        shadow={false}
                    >
                        <Cross1Icon style={{ width: '20px', height: '20px' }} />
                    </Button>
                </div>
            )}

            <ConfigQrCode
                data={barcode}
                description=""
                filename={label}
                className="h-full "
                showPrintDownloadButtons={showPrintDownloadButtons}
            />
        </div>
    )
}
